export default __webpack_public_path__ + "static/media/hero-pattern.13eb269c.png";